module.exports = __webpack_public_path__ + "static/media/arrow-left-disabled.d6d5344d.svg";